import { jsx } from "react/jsx-runtime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { validateTidalLicense } from "../../base/index.js";
function CalendarToday(props) {
  return /* @__PURE__ */ jsx(
    CalendarTodayIcon,
    {
      "data-testid": "CalendarToday",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CalendarToday",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
CalendarToday.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "CalendarToday"
};
validateTidalLicense();
export {
  CalendarToday
};
//# sourceMappingURL=CalendarToday.js.map
